import { CSVProfile, Pagination, IDropdownMenu } from '../../types'
import isUndefined from 'lodash/isUndefined'
import isEmpty from 'lodash/isEmpty'
import { CSVMenuItem } from '../../charts-factory'

import { ExportToCsv } from '../utils/csv-export-utils'
import angular from 'angular'

export class BaseWidget {
    static config = {
        selector: 'baseWidget',
        controller: BaseWidget,
        bindings: {
            componentTemplate: '<',
            visualizationId: '<',
            properties: '<',
            vizData: '<',
            userTimeZone: '<',
            onUpdate: '<',
            isLoading: '<',
            isError: '<',
            dateRange: '<',
            visualizationMetaData: '<?',
            treatments: '<',
            hasSplit: '<',
            isRestricted: '<',
        },
        template: `
        <md-card class="viz__card"
        ng-if="( $ctrl.vizData && $ctrl.hasSplit ) || ($ctrl.isLoading) || $ctlr.isError"
        trigger-update="$ctrl.onUpdate"
        ng-class="{'hide-stuff':$ctrl.properties.hideToolbar}"
        viz-data="$ctrl.vizData">
            <mw-toolbar is-transparent="true" ng-if="!$ctrl.properties.hideToolbar">
                <mw-toolbar-title class="md-truncate">
                    <span translate>{{$ctrl.properties.title}} </span>
                    <flux-infotip>
                        <span ng-if="$ctrl.properties.info" translate>{{$ctrl.properties.info}}</span>
                        <span ng-if="$ctrl.properties.youtubeInfo"><br /><br/>
                            <span translate>{{$ctrl.properties.youtubeInfo}}</span>
                        </span>
                    </flux-infotip>
                </mw-toolbar-title>
                <div flex></div>

                <af-location-selector
                    ng-if="$ctrl.properties.isLocationSelector"
                    is-loading="$ctrl.isLoading"
                    on-select-change="$ctrl.handleLocationChange(location)">
                </af-location-selector>

                <flux-dropdown ng-if="$ctrl.dropdownMenu.length > 0" class="mw-menu" md-position-mode="target-right target" md-offset="0 52">
                    <flux-button slot="trigger">
                        <flux-icon slot="icon" name="actions:download"></flux-icon>
                        <flux-tooltip>{{'explore__sampled-exports--download-options' | translate}}</flux-tooltip>
                    </flux-button>
                    <flux-list>
                        <flux-list-item ng-repeat="item in $ctrl.dropdownMenu" ng-click="$ctrl.clickEvent(item.click)">
                            <span translate translate-default="{{ item.name }}">{{item.translationKey}}</span>
                        </flux-list-item>
                    </flux-list>
                </flux-dropdown>

            </mw-toolbar>
            <div class="af__chart__container af__{{$ctrl.properties.size}}" layout="row" layout-wrap >
                <div class="af__loader__container" ng-if="$ctrl.isLoading && !$ctrl.properties.hideToolbar">
                    <mw-loader></mw-loader>
                </div>

                <div
                    ng-if="(!$ctrl.isLoading || $ctrl.properties.hideToolbar) && (!$ctrl.showError($ctrl.isLoading, $ctrl.vizData))"
                    class="dc"
                    dynamic-component="$ctrl.componentTemplate"
                    dyn="$ctrl.componentTemplate"
                    props="$ctrl.properties">
                </div>

                <error-widget
                    ng-if="$ctrl.showError($ctrl.isLoading, $ctrl.vizData)"
                    error-data="$ctrl.vizData.error"
                    widget-size="$ctrl.properties.size"
                    class="dc">
                </error-widget>

            </div>

            <af-pagination
                ng-if="!$ctrl.isLoading && $ctrl.properties.isPagination && !($ctrl.visualizationId=='AF-topTwitterAuthors' && $ctrl.isRestricted) || !$ctrl.isLoading && $ctrl.properties.isPagination === 'hide'"
                pagination="$ctrl.pagination"
                hide-pag="$ctrl.pagination.hide"
                current-page="$ctrl.pagination.currentPage"
                page-size="$ctrl.pagination.pageSize"
                content-length="$ctrl.pagination.contentLength"
                pagination-title="$ctrl.properties.tilePagination"
                on-prev-clicked="$ctrl.onPrevPage($ctrl.pagination.currentPage)"
                on-next-clicked="$ctrl.onNextPage($ctrl.pagination.currentPage)">
            </af-pagination>
        </md-card>
    `,
    }

    public userTimeZone: any
    public onUpdate: any
    public isLoading: boolean
    public isError: boolean
    public dateRange: any
    public properties: any
    public vizData: any
    public options: any
    public visualizationMetaData
    public treatments: any = {}
    public hasSplit: any
    public isRestricted: boolean
    private dropdownMenu: IDropdownMenu[]
    private visualizationId: string

    //pagintation - current index.
    // pagination - controls the size of items that are visible in viewport.
    // pagination - data length to determine last page.
    public pagination: Pagination = {
        currentPage: 0,
        pageSize: 10,
        contentLength: 1,
        hide: false,
    }

    public csvExporter: ExportToCsv
    public csvExportProfiles: CSVProfile[] = []

    public locationType: any

    $onInit() {
        this.pagination.hide = this.properties.isPagination === 'hide' ? true : false
        this.properties = this.mergeProperties()

        //init CSV export
        this.csvExporter = new ExportToCsv()
    }

    /**
     * Method is triggered after changes in the datastore.
     * Thereafter, trigger methods to update the view.
     * @param changes data object with current and previous change value(s)
     */
    $onChanges(changes) {
        this.properties = this.mergeProperties()
        this.dropdownMenu = this.isLoading || this.isError || this.showError() ? [] : this.createDropdownMenu()
    }

    isObjEmpty(data) {
        return Object.keys(data).length === 0 && data.constructor === Object
    }

    /**
     * Merge/include global properties to be passed to dynamic child component(s)
     */
    mergeProperties() {
        return Object.assign(this.properties, {
            vizData: this.vizData,
            userTimeZone: this.userTimeZone,
            onUpdate: this.onUpdate,
            isLoading: this.isLoading,
            isError: this.isError,
            dateRange: this.dateRange,
            pagination: this.pagination,
            csvExportProfiles: this.csvExportProfiles,
            visualizationMetaData: this.visualizationMetaData,
            locationType: this.locationType,
        })
    }

    onPrevPage(event) {
        if (this.pagination.currentPage !== 0) {
            this.pagination = Object.assign({}, this.pagination, {
                currentPage: this.pagination.currentPage - 1,
            })
        }
    }

    onNextPage(event) {
        if (this.pagination.currentPage < this.pagination.contentLength / this.pagination.pageSize - 1) {
            this.pagination = Object.assign({}, this.pagination, {
                currentPage: this.pagination.currentPage + 1,
            })
        }
    }

    exportCSV() {
        this.csvExporter.export(this.csvExportProfiles)
    }

    showError() {
        if(!this.isLoading && !isUndefined(this.vizData)) {
            if(this.isError || isUndefined(this.vizData)) {
                if(isUndefined(this.vizData.error) || isUndefined(this.vizData.error.message)) {
                    this.vizData = {error: {message: 'Data Failed'}}
                } else {
                    this.vizData.error.message = 'Data Failed'
                }

                this.pagination = Object.assign({}, this.pagination, {
                    contentLength: 0,
                })
                return true

            } else if(((isEmpty(this.vizData) || isEmpty(this.vizData.data)) && (isEmpty(this.vizData) || isEmpty(this.vizData.extendedData)) || ( !isEmpty(this.vizData.error)) )) {
                this.vizData.error = isUndefined(this.vizData.error) ? {message: 'Data Failed'} : this.vizData.error

                this.pagination = Object.assign({}, this.pagination, {
                    contentLength: 0,
                })
                return true

            } else {
                return false
            }
        } else {
            return false
        }
    }

    createDropdownMenu() {
        let menu = []
        if(!(this.visualizationId=='AF-topTwitterAuthors' && this.isRestricted) || this.properties.isMenuButton) {
            if(this.properties.isCSVExport) {
                menu.push(CSVMenuItem)
            }
        }
        return menu
    }

    clickEvent(clickEvent: string) {
        switch (clickEvent) {
            case 'exportCSV':
                this.exportCSV()
                break;
            default:
                break;
        }
    }

    handleLocationChange(location: any) {
        this.locationType = location;
    }
}
